import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'
import { SettingsFormFooter } from '@/containers/Settings/SettingsLayout'
import API from '@/lib/api'

const schema = z.object({
  footnote: z.string(),
})

type FootnoteFormData = z.infer<typeof schema>

export function FootnoteForm({
  defaultValues,
}: {
  defaultValues?: FootnoteFormData
}) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'settings',
  })
  const { t: tg } = useTranslation(undefined, {
    keyPrefix: 'generic',
  })

  const form = useForm<FootnoteFormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      footnote: defaultValues?.footnote || '',
    },
  })

  const onSubmit = (data: FootnoteFormData) =>
    API.patch('/api/v2/settings', {
      footnote: data.footnote,
    })
      .then(() => {
        toast.success(t('invoicing.generic.success'))
        form.reset(data)
      })
      .catch(() => {
        toast.error('Text v patičce se nepodařilo uložit.')
      })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="footnote"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('invoicing.footnote.label')}</FormLabel>
              <FormControl>
                <Textarea rows={5} className="min-h-28" {...field} />
              </FormControl>
              <FormMessage />
              <FormDescription>
                {t('invoicing.footnote.message')}
              </FormDescription>
              <p className="rounded-md bg-muted px-3 py-2 text-sm text-muted-foreground">
                {t('invoicing.footnote.example')}
              </p>
            </FormItem>
          )}
        />

        <SettingsFormFooter>
          <Button type="submit" disabled={form.formState.isSubmitting}>
            {tg('button.save')}
          </Button>
        </SettingsFormFooter>
      </form>
    </Form>
  )
}
